export default __webpack_public_path__ + "static/media/res2.fdeb2b5e.png";